'use strict';
import isDate from 'lodash/isDate';
import isFunction from 'lodash/isFunction';
import memoize from 'lodash/memoize';
import moment from 'moment';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ListItem} from '../../../components/lists/ListItem';

export class FeedItemView extends Component {
  static propTypes = {
    className: T.string,
    entry: T.object,
    isOwnFeed: T.bool,
    onClick: T.func,
  };

  static formatDate = memoize(date => moment(date).format('lll'), date => isDate(date) ? date.getTime() : date);

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if (isFunction(this.props.onClick)) {
      this.props.onClick(e, this.props.entry);
    }
  }

  render() {
    const ItemTag = this.props.isOwnFeed ? 'div' : ListItem;
    // TODO(css): Kill nested div. Replace with appropriate class(es) on parent
    return (
      <ItemTag
        className={classNames("FeedItem", this.props.className)}
        onClick={this.handleClick}
      >
        <div className="FeedItem__body">
          <i className={"icon " + this.props.entry.icon} />
          <div>
            <div className={"FeedItem__badge " + this.props.entry.tagName}>
              {this.props.entry.tagName}
            </div>
            <div className="FeedItem__message selectable">
              {this.props.entry.message}
            </div>
          </div>
          <div className="FeedItem__date">
            {FeedItemView.formatDate(this.props.entry.date)}
          </div>
        </div>
      </ItemTag>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/activity-feed/components/FeedItem/FeedItemView.js